<template>
	<page-container :page="page">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>
		<main-content
			v-if="!page.introblock"
			:title="page.title || page.header"
			:content="page.content"
			:intro-image="{
				image: page.introductionImage,
				imageWebp: page.introductionImageWebp,
			}"
		/>

		<intro-block v-if="page.introblock" :item="page.introblock" />

		<div class="row button-row">
			<div class="columns column12 align-center">
				<a v-for="item in menusFiltered" :key="item.ID" :href="`#menu-` + item.ID" class="menu-button button">
					{{ item.header }}
				</a>
			</div>
		</div>

		<section class="menu-section">
			<div class="row">
				<div v-for="item in menusFiltered" :key="item.ID" class="columns column12">
					<div :id="`menu-` + item.ID" class="item-anchor"></div>
					<div class="menu-item align-center">
						<h3>{{ item.header }}</h3>
						<div class="images">
							<nuxt-link
								v-for="(image, index) in item.images"
								:key="index"
								:to="getMenuLink(item)"
								target="_blank"
								class="image"
							>
								<picture>
									<source :srcset="image.imageWebp" type="image/webp" />
									<source :srcset="image.image" />
									<img :src="image.image" :alt="image.imageAlt" loading="lazy" />
								</picture>
							</nuxt-link>
						</div>
					</div>
				</div>
			</div>
		</section>

		<contentblocks :items="page.contentblocks" />
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { locale } = useI18n();

await fetchPage();

const { data: menus } = await useWebsiteFetch('menus', {
	query: { language: locale.value },
	key: `${locale.value}/menus`,
});

const menusFiltered = computed(() => {
	return menus.value.filter((menu) => menu.showOnMenuPage);
});

const getMenuLink = (item) => {
	switch (item.linkType) {
		case 'file':
			if (item.file) {
				return item.file;
			}
			break;
		case 'URL':
			if (item.url) {
				return item.url;
			}
			break;
		default:
			break;
	}

	return null;
};
</script>

<style lang="scss" scoped>
.menu-item {
	margin: 25px auto;
	padding: 15px 0 0;

	.image {
		margin-left: 15px;
		margin-right: 15px;
	}
}

.item-anchor {
	margin: -150px 0 150px;
}

.button-row {
	a {
		margin: 0 30px;
	}
}

.image {
	display: inline-block;
	width: 92%;
	margin: 25px auto;
	max-width: 724px;

	&::after {
		display: none;
	}
}
</style>
